import React from 'react';
import ReactDom from 'react-dom';
// import registerServiceWorker from './registerServiceWorker';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
// import createBrowserHistory from 'history/createBrowserHistory';
import './../node_modules/bootstrap/dist/css/bootstrap.min.css';
import './styles/style.css';

import clientRoutes from './routes/client';
import languageRoutes from './routes/language';
import clientproductRoutes from './routes/clientproduct';
import productRoutes from './routes/product';
import productoptionRoutes from './routes/productoption';
import clientproductstyleRoutes from './routes/clientproductstyle';
import clientproductoptionRoutes from './routes/clientproductoption';

import LoginScreen from './screens/LoginScreen/';
import RegisterScreen from './screens/RegistrationScreen/';
import DashboardScreen from './screens/DashboardScreen/';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
// import { syncHistoryWithStore } from 'react-router-redux'
import store from './store';

// const history = syncHistoryWithStore(createBrowserHistory(), store);

const root = document.getElementById('betwidgets-app-root');
const locale = root.getAttribute('data-locale');

ReactDom.render(
    <Provider store={store}>
      <MuiThemeProvider muiTheme={getMuiTheme()}>
        <BrowserRouter>
          <Switch>
            <Route path='/' render={((props) => <LoginScreen {...props} locale={locale} />)}  exact={true} key='login' />
            <Route path='/login' render={((props) => <LoginScreen {...props} locale={locale} />)}  exact={true} key='login' />
            <Route path='/register' render={((props) => <RegisterScreen {...props} locale={locale} />)}  exact={true} key='register' />
            <Route path='/dashboard' render={((props) => <DashboardScreen {...props} locale={locale} />)}  exact={true} key='dashboard' />
            {clientRoutes}
            {languageRoutes}
            {clientproductRoutes}
            {productRoutes}
            {productoptionRoutes}
            {clientproductstyleRoutes}
            {clientproductoptionRoutes}
            <Redirect to="/" />
          </Switch>
        </BrowserRouter>
    </MuiThemeProvider>
  </Provider>,
  root
);

// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js